import InlineChromiumBugfix from "@/components/InlineChromiumBugFix";
import { RenderTypedElementProps } from "../TypedElement";
import QuantityObservationInput from "@/components/inputs/ObservationInput/QuantityObservationInput";
import { SettingsPanelPortal } from "@/components/layout/SettingsPanel";
import { Transition } from "@headlessui/react";
import PropertiesForm from "./QuantityPropertiesForm";
import useSlateInputElement from "@/editor/utils/useSlateInputElement";
import { IQuantityObservationInputElement } from "./types";

type RenderQuantityInputElementProps = RenderTypedElementProps & {
  element: IQuantityObservationInputElement;
};
const RenderQuantityObservationInput = (
  props: RenderQuantityInputElementProps
) => {
  const { element, attributes, children } = props;
  const { children: _, name: __, ...other } = element;
  const { name, update, disabled, showProperties, active } =
    useSlateInputElement(element);
  return (
    <span {...attributes} tabIndex={-1}>
      <InlineChromiumBugfix />
      <QuantityObservationInput
        name={name}
        active={active}
        disabled={disabled}
        {...other}
      />
      {children}
      <InlineChromiumBugfix />
      <SettingsPanelPortal>
        <Transition show={showProperties} enter="ease-in-out duration-75">
          <PropertiesForm onSubmit={update} defaultValues={element} />
        </Transition>
      </SettingsPanelPortal>
    </span>
  );
};

export default RenderQuantityObservationInput;
